export const ALLOCATED_AMOUNT_TYPE_TOTAL = "ALLOCATED_AMOUNT_TYPE_TOTAL"
export const ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS = "ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS"
export const ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS = "ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS"

export const TYPES = [ALLOCATED_AMOUNT_TYPE_TOTAL, ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS, ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS]
export const TYPES_DATA = {
   [ALLOCATED_AMOUNT_TYPE_TOTAL]: {"Spanish": "budget_types.total_amount"},
   [ALLOCATED_AMOUNT_TYPE_SUM_OF_CAMPAIGNS]: {"Spanish": "budget_types.sum_of_campaigns"},
   [ALLOCATED_AMOUNT_TYPE_SUM_OF_ADGROUPS]: {"Spanish": "budget_types.sum_of_adgroups"}
}
